import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const usersAdapter = getAdapter();
const usersSlice = createSlice({
  name: 'users',
  initialState: usersAdapter.getInitialState(),
  reducers: {
    setUsers: (state, { payload: { users } }) => {
      usersAdapter.setAll(state, users);
    }
  }
});

const selectors = usersAdapter.getSelectors(({ users }) => users);

export const getUsersIncludingDeleted = state => selectors.selectAll(state);

export const getUsers = state => getUsersIncludingDeleted(state).filter(({ active }) => active);

export const { setUsers } = usersSlice.actions;

export default usersSlice.reducer;
